import { render, staticRenderFns } from "./hotelNoAdv.vue?vue&type=template&id=6c0936f1&scoped=true"
import script from "./hotelNoAdv.vue?vue&type=script&lang=js"
export * from "./hotelNoAdv.vue?vue&type=script&lang=js"
import style0 from "./hotelNoAdv.vue?vue&type=style&index=0&id=6c0936f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0936f1",
  null
  
)

export default component.exports